import React from 'react';
import {UnitList} from "components/unit/UnitList";
import {Provider} from "components/unit/UnitContext";

export const Units = () => {

    return (
        <Provider>
            <UnitList/>
        </Provider>
    );
}
